module.exports = __webpack_public_path__ + "img/Support-skill-312.444808ec.png";